import classnames from 'classnames';
import React from 'react';
import './OverlaySection.css';

interface Props {
  label: React.ReactNode;
  tabMode?: boolean;
}

class OverlaySection extends React.Component<Props> {
  static defaultProps = {
    tabMode: false,
  };

  render(): React.ReactNode {
    const { label, children, tabMode } = this.props;

    return (
      <div className="overlay-section w100 mb2 pos-r">
        <div className="overlay-section-label medium size-16 black-2 hrem-3 row items-center">
          {label}
        </div>
        <div
          className={classnames(
            'overlay-section-body bgd-light-grey-2 b-solid b-width-1 b-light-grey-1 p3 light font-size-5 color-gray-7',
            {
              'tab-mode': tabMode,
            }
          )}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default OverlaySection;
